import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { useSelector, useDispatch } from 'react-redux';
import { setPhysics, setSelfReference } from '../../features/networkSlice';

export default function Handler() {
  const dispatch = useDispatch();
  const physics = useSelector((state) => state.network.physics);
  const selfReference = useSelector((state) => state.network.selfReference);

  return (
    <>
      <FormControlLabel
        control={<Switch />}
        label="Interactive"
        onChange={() => dispatch(setPhysics(!physics))}
        checked={physics}
        sx={{ ml: 3 }}
      />
      <FormControlLabel
        control={<Switch />}
        label="Self effects"
        title="Show/hide self effects"
        onChange={() => dispatch(setSelfReference(!selfReference))}
        checked={selfReference}
        sx={{ ml: 3 }}
      />
    </>
  );
}
